import {
  CardFormFactor,
  CardType,
  FormFactorSelectorContext,
} from '../../../../../enums';
import { FormFactorSelector } from '../../Common/FormFactorSelector';

interface CardFormFactorSelectorProps {
  cardType: CardType;
  selectedCardFormFactor?: CardFormFactor;
  onCardFormFactorChange: (formFactor: CardFormFactor) => void;
  onContinueClick: () => void;
}

export const CardFormFactorSelector = (props: CardFormFactorSelectorProps) => {
  const {
    cardType,
    selectedCardFormFactor,
    onCardFormFactorChange,
    onContinueClick,
  } = props;

  return (
    <FormFactorSelector
      cardType={cardType}
      selectedCardFormFactor={selectedCardFormFactor}
      onCardFormFactorChange={onCardFormFactorChange}
      onButtonClick={onContinueClick}
      contextType={FormFactorSelectorContext.Buy}
    />
  );
};
